module.exports = __webpack_public_path__ + "static/media/dataset-4.8c3e7f70.PNG";